// extracted by mini-css-extract-plugin
module.exports = {"time":"_c8c0c01","timeXs":"_bad4367","timeSm":"_aaf95ba"};